/*@cfg-v16  2026-10-29*/




const MODELS = window.MODEL_DATA || [];
const STRAPS = window.STRAP_DATA || [];
const MASK_SRC = window.STRAP_MASK || '';



const CASES = window.CASE_DATA || [];


const BEZELS = window.BEZEL_DATA || [];

const CASE_DOT = {
  'steel':    'linear-gradient(135deg,#f2f3f5,#b7bac0 45%,#e9ebee 58%,#9ea2a9)',
  'gold':     'linear-gradient(135deg,#f8ecc6,#c9a34a 45%,#f5e3ad 58%,#a9832f)',
  'rose':     'linear-gradient(135deg,#f9e0d4,#c98a6f 45%,#f5d6c6 58%,#a96a4e)',
  'two-tone': 'linear-gradient(90deg,#e9ebee 0 50%,#d9b45e 50% 100%)',
};



const MODEL_LABEL = window.MODEL_SET_LABEL || 'Custom';










let WATCH_SPECS = [

  { k:'Case diameter',   v:'42 mm' },
  { k:'Case thickness',  v:'13.2 mm' },
  { k:'Lug-to-lug',      v:'50 mm' },
  { k:'Lug width',       v:'22 mm' },
  { k:'Case material',   v:'Stainless steel' },

  { k:'Crystal',         v:'Sapphire' },
  { k:'Movement',        v:'3600' },
  { k:'Water resistance',v:'10 bar (100 m)' },
  { k:'Case back',       v:'Solid / Transparent' },
  { k:'Strap length',    v:'22 cm' },
];










if(Array.isArray(window.MODEL_SET_SPECS)){
  WATCH_SPECS = window.MODEL_SET_SPECS.map(p => ({ k: p[0], v: p[1] }));
}








function specsFromAdmin(){
  const raw = window.WATCH_SPECS_ADMIN;
  if(typeof raw !== 'string' || !raw.trim()) return null;
  const out = [];
  raw.split(/\r?\n/).forEach(line => {


    const a = line.indexOf(':'), b = line.indexOf('：');
    let i;
    if(a < 0) i = b;
    else if(b < 0) i = a;
    else i = Math.min(a, b);
    if(i < 1) return;
    const k = line.slice(0, i).trim();
    const v = line.slice(i + 1).trim();
    if(k && v) out.push({ k, v });
  });
  return out.length ? out : null;
}

function renderSpecs(){
  const box = $('#specsBox');
  if(!box) return;
  const rows = WATCH_SPECS.filter(s => s.v);
  if(!rows.length){ box.hidden = true; box.innerHTML = ''; return; }
  box.hidden = false;
  box.innerHTML = rows.map(s =>
    `<div><dt>${s.k}</dt><dd>${s.v}</dd></div>`).join('');
}









function placeSpecs(){
  const box = $('#specsBox');
  if(!box) return;
  const panel = document.querySelector('.cfg .panel') || document.querySelector('.panel');
  if(!panel) return;

  const anchor = panel.querySelector('.sec.sum') || panel.querySelector('.actions');
  if(box.parentElement === panel) return;
  if(anchor) panel.insertBefore(box, anchor);
  else panel.appendChild(box);
}
















function _normTitle(t){
  return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
}

function _mapKeys(src){
  const out = {};
  for(const k in src) out[_normTitle(k)] = src[k];
  return out;
}

const TITLE_TO_QTY = _mapKeys({
  'sample 1':'1', '1 pc':'1', '1 pcs':'1',
  '10 pcs':'10', '20 pcs':'20', '30 pcs':'30', '50 pcs':'50', '100 pcs':'100',
});
const TITLE_TO_FEE = _mapKeys({
  'laser':'LG1',
  'label black':'LG2-black', 'label white':'LG2-white', 'label silver':'LG2-silver',
  'label rose gold':'LG2-rose', 'label gold':'LG2-gold',
  'print 1 colour':'LG3-1', 'print 2 colours':'LG3-2', 'print 3 colours':'LG3-3',
  'print 4 colours':'LG3-4', 'print 5 colours':'LG3-5',
  'print 1 color':'LG3-1', 'print 2 colors':'LG3-2', 'print 3 colors':'LG3-3',
  'print 4 colors':'LG3-4', 'print 5 colors':'LG3-5',

  'engrave':'ENG', 'engraving':'ENG', 'case back engraving':'ENG',
});






let _vm = null, _vmSrc = null;
function variantMaps(){
  const raw = window.SHOPIFY_VARIANTS || {};
  if(_vm && _vmSrc === raw) return _vm;
  const qty = {}, fee = {};
  for(const t in (raw.qty || {})){
    const k = TITLE_TO_QTY[_normTitle(t)];
    if(k) qty[k] = normaliseVariant(raw.qty[t]);
  }
  for(const t in (raw.fee || {})){
    const k = TITLE_TO_FEE[_normTitle(t)];
    if(k) fee[k] = normaliseVariant(raw.fee[t]);
  }
  _vm = { qty, fee };
  _vmSrc = raw;
  return _vm;
}


function normaliseVariant(v){
  if(v && typeof v === 'object') return { id: v.id || null, price: numOrNull(v.price) };
  return { id: v || null, price: null };
}
function numOrNull(v){
  const n = parseFloat(v);
  return isFinite(n) && n > 0 ? n : null;
}


function qtyVariantId(q){
  const v = variantMaps().qty[String(q)];
  return v ? v.id : null;
}

function qtyUnitPrice(q){
  const v = variantMaps().qty[String(q)];
  if(v && v.price) return v.price;
  return BASE_PRICE * tierFactor(q);
}


function feeSkuKey(){
  if(!state.logo || state.logoType === 'LG0') return null;
  if(state.logoType === 'LG1') return 'LG1';
  if(state.logoType === 'LG2') return 'LG2-' + state.labelColor;
  if(state.logoType === 'LG3') return 'LG3-' + state.printColors;
  return null;
}
function feeVariantId(){
  const k = feeSkuKey();
  const v = k ? variantMaps().fee[k] : null;
  return v ? v.id : null;
}

function feeVariantPrice(){
  const k = feeSkuKey();
  const v = k ? variantMaps().fee[k] : null;
  return v ? v.price : null;
}



function feePriceOr(key, fallback){
  const v = variantMaps().fee[key];
  return (v && v.price != null) ? v.price : fallback;
}
function laserFee()     { return feePriceOr('LG1', 5); }
function labelFee(c)    { return c.usd == null ? null : feePriceOr('LG2-' + c.id, c.usd + LABEL_MOLD); }
function printFeeNow(n) { return feePriceOr('LG3-' + n, printFee(n)); }
function labelFeeRange(){
  const vals = LABEL_COLORS.filter(c => c.usd != null).map(labelFee);
  return vals.length ? [Math.min.apply(null, vals), Math.max.apply(null, vals)] : null;
}


function canCheckout(){
  if(!qtyVariantId(state.qty)) return false;
  if(feeSkuKey() && !feeVariantId()) return false;


  if(state.engrave && !engraveVariantId()) return false;
  return true;
}





const BASE_PRICE = 80.00;





const DIAL_DOT = {
  'WHITE':   'radial-gradient(circle,#f4f3ef 56%,#232323 57%,#232323 67%,#f4f3ef 68%)',
  'GREEN':   'radial-gradient(circle,#47532B 56%,#c8d69b 57%,#c8d69b 67%,#47532B 68%)',
  'BLUE':    'radial-gradient(circle,#1A4F6F 56%,#e6e2d6 57%,#e6e2d6 67%,#1A4F6F 68%)',
  'BLACK-G': 'radial-gradient(circle,#232323 56%,#c8d69b 57%,#c8d69b 67%,#232323 68%)',
  'BLACK-Y': 'radial-gradient(circle,#232323 56%,#c8a44d 57%,#c8a44d 67%,#232323 68%)',
};




const QTY_TIERS = [
  { qty: 1,   factor: 1.55, label: 'Sample · 1' },
  { qty: 10,  factor: 1.38, label: '10 pcs' },
  { qty: 20,  factor: 1.28, label: '20 pcs' },
  { qty: 30,  factor: 1.20, label: '30 pcs' },
  { qty: 50,  factor: 1.12, label: '50 pcs' },
  { qty: 100, factor: 1.00, label: '100 pcs' },
];



function tierFactor(q){
  const first = QTY_TIERS[0], last = QTY_TIERS[QTY_TIERS.length - 1];
  if(q <= first.qty) return first.factor;
  if(q >= last.qty) return last.factor;
  for(let i = 0; i < QTY_TIERS.length - 1; i++){
    const a = QTY_TIERS[i], b = QTY_TIERS[i + 1];
    if(q >= a.qty && q <= b.qty){
      const t = (q - a.qty) / (b.qty - a.qty);
      return a.factor + (b.factor - a.factor) * t;
    }
  }
  return last.factor;
}


const LOGO_METHODS = [
  { id:'LG0', name:'No logo', mode:'none',
    note:'Standard stock dial', fee:0 },
  { id:'LG1', name:'Laser engraving', mode:'laser',
    note:'Off-white · no tooling · 1 colour', fee:5 },
  { id:'LG2', name:'Label', mode:'label',
    note:'Material colour · tooling required', fee:null },
  { id:'LG3', name:'Printing', mode:'print',
    note:'Reproduces artwork · per colour', fee:null },
];


const LASER_HEX = '#f3ecd8';
const LASER_LUM = 241;


const LABEL_MOLD = 40;
const LABEL_COLORS = [
  { id:'black',  name:'Black',     hex:'#17181a', usd:40, lum:12  },
  { id:'white',  name:'White',     hex:'#f1f0ea', usd:40, lum:250 },
  { id:'silver', name:'Silver',    hex:'#c6cbd1', usd:30, lum:214 },
  { id:'rose',   name:'Rose gold', hex:'#d8a294', usd:30, lum:178 },
  { id:'gold',   name:'Gold',      hex:'#c8a44d', usd:30, lum:176 },
  { id:'other',  name:'Other',     hex:'other',   usd:null, lum:128 },
];




const PRINT_FIRST = 40;
const PRINT_EXTRA = 10;
const PRINT_MAX_COLORS = 5;
function printFee(n){ return PRINT_FIRST + PRINT_EXTRA * (Math.max(1, n) - 1); }








const ENGRAVE_FEE = 25;
const ENGRAVE_MAX = 10;
const ENGRAVE_FONTS = [
  { id:'arial',  name:'Arial',  code:'AR',
    stack:"Arial,Helvetica,'Liberation Sans',sans-serif" },




  { id:'script', name:'Script', code:'SC',
    stack:"'Segoe Script','Brush Script MT','Bradley Hand','Snell Roundhand','Apple Chancery',cursive" },
  { id:'gothic', name:'Gothic', code:'GO',
    stack:"'Old English Text MT','UnifrakturMaguntia','Blackadder ITC','Luminari',fantasy" },
];


function money(v, dec){
  const d = (dec == null) ? 2 : dec;
  return '$' + Number(v).toLocaleString('en-US',
    { minimumFractionDigits: d, maximumFractionDigits: d });
}




const state = {
  model: MODELS.length ? MODELS[0].id : null,

  case: CASES.length ? CASES[0].id : null,

  bezel: BEZELS.length ? BEZELS[0].id : null,


  bezelPinned: false,
  strap: STRAPS.length ? STRAPS[0].id : null,
  qty: 100,
  custom: false,
  logoType: 'LG0',
  labelColor: 'black',
  printColors: 1,
  logo: null,
  logoMeta: null,

  engrave: false,
  engraveFont: 'arial',
  engraveText: '',
};




function dialList(){ return MODELS.filter(m => !m.hidden); }

if(CASES.length){
  const first = MODELS.find(m => (m.case || '') === state.case && !m.hidden);
  if(first) state.model = first.id;
}
if(!state.model || !MODELS.some(m => m.id === state.model && !m.hidden)){
  const f = dialList()[0];
  if(f) state.model = f.id;
}

const $ = s => document.querySelector(s);
const svg = $('#watch');

function model(){ return MODELS.find(m => m.id === state.model) || dialList()[0] || MODELS[0]; }
function caseOf(){ return CASES.find(c => c.id === state.case) || CASES[0] || null; }
function strap(){ return STRAPS.find(s => s.id === state.strap) || STRAPS[0]; }
function method(){ return LOGO_METHODS.find(t => t.id === state.logoType) || LOGO_METHODS[0]; }
function labelColor(){
  return LABEL_COLORS.find(c => c.id === state.labelColor) || LABEL_COLORS[0];
}

function bezel(){ return BEZELS.find(b => b.id === state.bezel) || BEZELS[0] || null; }

function engraveFont(){
  return ENGRAVE_FONTS.find(f => f.id === state.engraveFont) || ENGRAVE_FONTS[0];
}



function defaultBezelFor(dialId){
  const hit = BEZELS.find(b => b.donor === dialId);
  return (hit || BEZELS[0] || {}).id || null;
}


function logoFee(){
  const t = method();
  if(!state.logo || t.mode === 'none') return { usd:0, items:[] };

  if(t.mode === 'laser'){
    const f = laserFee();
    return { usd:f, items:[{ n:'Laser engraving (one-time)', usd:f }] };
  }

  if(t.mode === 'label'){
    const c = labelColor();
    if(c.usd == null)
      return { usd:null, items:[{ n:`${c.name} label (quote needed)`, usd:null }] };
    return { usd:labelFee(c), items:[
      { n:`${c.name} label material`, usd:c.usd },
      { n:'Tooling (one-time)',       usd:LABEL_MOLD },
    ]};
  }

  const n = state.printColors;
  const extra = Math.max(0, n - 1);
  const items = [{ n:'Printing 1 colour (one-time)', usd:PRINT_FIRST }];
  if(extra > 0) items.push({
    n:`${extra} extra colour${extra > 1 ? 's' : ''} × ${money(PRINT_EXTRA)}`,
    usd:PRINT_EXTRA * extra,
  });
  return { usd:printFeeNow(n), items };
}



function engraveFee(){
  if(!state.engrave) return { usd:0, items:[] };
  const f = engraveFont();
  const txt = (state.engraveText || '').trim();
  const usd = engraveVariantPrice() != null ? engraveVariantPrice() : ENGRAVE_FEE;
  return { usd, items:[
    { n:`Case back engraving · ${f.name}${txt ? ' · "' + txt + '"' : ' · text pending'}`,
      usd },
  ]};
}


function engraveVariantId(){
  if(!state.engrave) return null;
  const v = variantMaps().fee['ENG'];
  return v ? v.id : null;
}
function engraveVariantPrice(){
  if(!state.engrave) return null;
  const v = variantMaps().fee['ENG'];
  return v ? v.price : null;
}














const IMG = {};



let maskImgs = {};
let lastDial = null;
const CACHE = new Map();

function maskFor(baseId){
  return maskImgs[baseId] || maskImgs[''] || null;
}

function preload(){
  const jobs = MODELS.map(m => new Promise(res => {
    const im = new Image();
    im.onload = im.onerror = () => { IMG[m.id] = im; res(); };
    im.src = m.img;
  }));
  const list = (typeof MASK_SRC === 'string')
    ? [['', MASK_SRC]]
    : Object.keys(MASK_SRC || {}).map(k => [k, MASK_SRC[k]]);
  list.forEach(([key, src]) => jobs.push(new Promise(res => {
    const im = new Image();
    im.onload = im.onerror = () => { maskImgs[key] = im; res(); };
    im.src = src;
  })));
  return Promise.all(jobs);
}

function compositeUrl(baseId, donorId){
  const bm = MODELS.find(m => m.id === baseId);
  if(!bm) return '';
  if(!donorId || donorId === baseId) return bm.img;

  const key = baseId + '|' + donorId;
  if(CACHE.has(key)) return CACHE.get(key);

  const b = IMG[baseId], d = IMG[donorId];
  const mk = maskFor(baseId);
  if(!b || !d || !mk) return bm.img;

  const S = 1200;
  const t = document.createElement('canvas');
  t.width = t.height = S;
  const tx = t.getContext('2d');
  tx.drawImage(d, 0, 0, S, S);
  tx.globalCompositeOperation = 'destination-in';
  tx.drawImage(mk, 0, 0, S, S);

  const c = document.createElement('canvas');
  c.width = c.height = S;
  const cx2 = c.getContext('2d');
  cx2.drawImage(b, 0, 0, S, S);
  cx2.drawImage(t, 0, 0);

  let url = bm.img;
  try{ url = c.toDataURL('image/jpeg', 0.93); }catch(e){}
  CACHE.set(key, url);
  return url;
}


















function dialPath(ctx0, m, gx, gy, rad, k){
  const g = m.dial;
  if(g && g.shape === 'octagon' && g.pts && g.pts.length >= 3){
    ctx0.beginPath();
    g.pts.forEach((p, i) => {
      const X = p[0] * k, Y = p[1] * k;
      i ? ctx0.lineTo(X, Y) : ctx0.moveTo(X, Y);
    });
    ctx0.closePath();
    return;
  }
  ctx0.beginPath();
  ctx0.arc(gx, gy, rad, 0, Math.PI * 2);
}

function dialCompositeUrl(caseBaseId, dialId, bezelId, strapDonorId){
  const m = model();


  const dm = (dialId && MODELS.find(x => x.id === dialId)) || m;
  const sameDial = !dialId || dialId === caseBaseId;
  const bez = bezelId ? BEZELS.find(b => b.id === bezelId) : null;

  const stockBez = !bez || bez.donor === caseBaseId;

  const mk = maskFor(caseBaseId);
  const needStrap = !!(strapDonorId && strapDonorId !== caseBaseId && mk);
  if(sameDial && stockBez && !needStrap) return dm.img;

  const key = [caseBaseId, dialId, bezelId || '-', strapDonorId || '-', 'dial'].join('|');
  if(CACHE.has(key)) return CACHE.get(key);

  const b = IMG[caseBaseId];
  const d = sameDial ? b : IMG[dialId];
  const bz = (bez && !stockBez) ? IMG[bez.donor] : null;
  const sd = needStrap ? IMG[strapDonorId] : null;
  if(!b || !d || ((bez && !stockBez) && !bz) || (needStrap && !sd)) return dm.img;




  const bm = MODELS.find(x => x.id === caseBaseId);
  const ro = Math.min((bm && bm.dial.outer) || m.dial.outer || m.dial.r,
                      m.dial.outer || m.dial.r);

  const S = 1200, k = S / 2000;
  const c = document.createElement('canvas');
  c.width = c.height = S;
  const cx = c.getContext('2d');
  cx.drawImage(b, 0, 0, S, S);

  const gx = m.dial.cx * k, gy = m.dial.cy * k;



  if(bz){
    const rd = ro * k;
    const rout = (m.dial.bezel_out || ro * 1.2) * k;
    cx.save();
    cx.beginPath();
    cx.arc(gx, gy, rout, 0, Math.PI * 2);
    cx.arc(gx, gy, rd, 0, Math.PI * 2, true);
    cx.clip();
    cx.drawImage(bz, 0, 0, S, S);
    cx.restore();
  }


  if(!sameDial){
    cx.save();
    dialPath(cx, m, gx, gy, ro * k, k);
    cx.clip();
    cx.drawImage(d, 0, 0, S, S);
    cx.restore();
  }




  if(needStrap && sd){
    const tmp = document.createElement('canvas');
    tmp.width = tmp.height = S;
    const tcx = tmp.getContext('2d');
    tcx.drawImage(sd, 0, 0, S, S);
    tcx.globalCompositeOperation = 'destination-in';
    tcx.drawImage(mk, 0, 0, S, S);
    cx.drawImage(tmp, 0, 0);
  }

  let url = dm.img;
  try{ url = c.toDataURL('image/jpeg', 0.94); }catch(e){}
  CACHE.set(key, url);
  return url;
}

function applyModel(){
  const m = model();
  const s = strap();





  if(state.logo && lastDial && (lastDial.cx !== m.dial.cx || lastDial.cy !== m.dial.cy)){
    state.logo.x += m.dial.cx - lastDial.cx;
    state.logo.y += m.dial.cy - lastDial.cy;
  }
  lastDial = { cx: m.dial.cx, cy: m.dial.cy };


  const c0 = caseOf();
  const bz = bezel();
  const baseId = (CASES.length && c0) ? c0.base : m.id;
  $('#baseImg').setAttribute('href', (CASES.length || BEZELS.length)
    ? dialCompositeUrl(baseId, m.id, bz ? bz.id : null, s ? s.donor : null)
    : compositeUrl(m.id, s ? s.donor : null));



  const c = $('#clipCircle'), poly = $('#clipPoly');
  const oct = m.dial.shape === 'octagon' && m.dial.pts && m.dial.pts.length >= 3;
  if(c){
    c.setAttribute('cx', m.dial.cx);
    c.setAttribute('cy', m.dial.cy);
    c.setAttribute('r', oct ? 0 : m.dial.r);
  }
  if(poly){
    poly.setAttribute('points', oct
      ? m.dial.pts.map(p => p[0].toFixed(1) + ',' + p[1].toFixed(1)).join(' ')
      : '');
  }


  const h = m.hands, hi = $('#handsImg');
  if(h && hi){
    hi.setAttribute('href', h.src);
    hi.setAttribute('x', h.x); hi.setAttribute('y', h.y);
    hi.setAttribute('width', h.w); hi.setAttribute('height', h.h);
  }



  const wt = document.getElementById('watchTitle');
  if(wt){
    const caseName = (CASES.length && c0) ? ' on ' + c0.name + ' case and bracelet' : '';
    const bezName = (BEZELS.length && bz) ? ' with ' + bz.name + ' bezel' : '';
    wt.textContent = m.name + caseName + bezName + ' — custom watch preview';
  }
}





function logoStyle(){
  const m = model();
  const t = method();
  if(!state.logo || t.mode === 'none') return null;

  const dark = m.isDark;

  if(t.mode === 'laser'){


    return { blend:'normal', tint:LASER_HEX,
             opacity:0.92 * state.logo.opa, blur:0.4,
             bevel:'dark', bevelOpa:0.30 };
  }

  if(t.mode === 'label'){



    const c = labelColor();
    return { blend:'normal', tint: c.hex === 'other' ? null : c.hex,
             shadow:'drop-shadow(0 2px 2.2px rgba(0,0,0,.42))',
             opacity:state.logo.opa, blur:0.35, bevel:null };
  }



  return {
    blend: dark ? 'normal' : 'multiply',
    tint: null,
    opacity: 0.92 * state.logo.opa,
    blur: 0.6,
    bevel: null
  };
}






function tintDef(hex, prefix){
  prefix = prefix || '';
  return `<defs><filter id="${prefix}tintLogo" x="-15%" y="-15%" width="130%" height="130%"
      color-interpolation-filters="sRGB">
      <feFlood flood-color="${hex}" result="c"/>
      <feComposite in="c" in2="SourceAlpha" operator="in"/>
    </filter></defs>`;
}



function logoMarkup(prefix){
  prefix = prefix || '';
  const st = logoStyle();
  if(!st) return { g:'', box:'' };
  const L = state.logo;
  const cx = L.x + L.w/2, cy = L.y + L.h/2;
  const rot = `rotate(${L.rot} ${cx} ${cy})`;



  const bo = (st.bevelOpa || 0) * state.logo.opa;
  let bevel = '';
  if(st.bevel === 'dark'){
    bevel = `<image href="${L.src}" x="${L.x+1.7}" y="${L.y+2.1}" width="${L.w}" height="${L.h}"
      opacity="${bo.toFixed(3)}" transform="${rot}"
      style="mix-blend-mode:multiply;filter:brightness(0) blur(${(st.blur+0.8).toFixed(2)}px)"
      preserveAspectRatio="xMidYMid meet"/>`;
  }else if(st.bevel === 'light'){
    bevel = `<image href="${L.src}" x="${L.x-1.3}" y="${L.y-1.7}" width="${L.w}" height="${L.h}"
      opacity="${bo.toFixed(3)}" transform="${rot}"
      style="mix-blend-mode:screen;filter:brightness(0) invert(1) blur(${(st.blur+0.6).toFixed(2)}px)"
      preserveAspectRatio="xMidYMid meet"/>`;
  }

  const chain = [
    st.tint ? `url(#${prefix}tintLogo)` : '',
    `blur(${st.blur}px)`,
    st.shadow || ''
  ].filter(Boolean).join(' ');

  const g = `
    ${st.tint ? tintDef(st.tint, prefix) : ''}
    ${bevel}
    <image id="${prefix}logoImg" href="${L.src}" x="${L.x}" y="${L.y}" width="${L.w}" height="${L.h}"
           opacity="${st.opacity.toFixed(3)}"
           transform="${rot}"
           style="mix-blend-mode:${st.blend};filter:${chain};cursor:move"
           preserveAspectRatio="xMidYMid meet"/>`;




  const box = `
    <rect id="${prefix}logoBox" x="${L.x-6}" y="${L.y-6}" width="${L.w+12}" height="${L.h+12}"
          fill="none" stroke="#c8a24a" stroke-width="2" stroke-dasharray="8 8"
          opacity="${prefix ? 0.6 : 0}" transform="${rot}" pointer-events="none"/>`;






  let handles = '';
  if(prefix){
    const HS = 11, bx = L.x - 6, by = L.y - 6, bw = L.w + 12, bh = L.h + 12;
    const cs = [['nw', bx, by, 'nwse'], ['ne', bx+bw, by, 'nesw'],
                ['sw', bx, by+bh, 'nesw'], ['se', bx+bw, by+bh, 'nwse']];
    handles = `<g transform="${rot}">` + cs.map(([k, hx, hy, cur]) =>
      `<rect id="${prefix}handle-${k}" x="${(hx-HS).toFixed(1)}" y="${(hy-HS).toFixed(1)}"
             width="${HS*2}" height="${HS*2}" rx="3.5"
             fill="#ffffff" stroke="#c8a24a" stroke-width="2.6"
             style="cursor:${cur}-resize" pointer-events="all"/>`).join('') + `</g>`;
  }

  return { g, box: box + handles };
}

function renderLogo(){
  const g = $('#gLogo'), gb = $('#gBox');
  const m = logoMarkup('');
  g.innerHTML = m.g;
  gb.innerHTML = m.box;
}


function syncZoomLogo(){
  const zg = document.getElementById('z-gLogo');
  if(!zg) return;
  const zgb = document.getElementById('z-gBox');
  const m = logoMarkup('z-');
  zg.innerHTML = m.g;
  if(zgb) zgb.innerHTML = m.box;
}

function renderGuide(){
  const m = model();
  const { cx, cy, r } = m.dial;
  $('#gGuide').innerHTML = `
    <circle cx="${cx}" cy="${cy}" r="${r}" fill="none" stroke="#e0342b" stroke-width="3" opacity=".85"/>
    <circle cx="${cx}" cy="${cy}" r="${r*0.86}" fill="none" stroke="#2f6fd0" stroke-width="2"
            stroke-dasharray="10 8" opacity=".7"/>
    <line x1="${cx-40}" y1="${cy}" x2="${cx+40}" y2="${cy}" stroke="#c8a24a" stroke-width="3"/>
    <line x1="${cx}" y1="${cy-40}" x2="${cx}" y2="${cy+40}" stroke="#c8a24a" stroke-width="3"/>`;
}




function buildPicks(){

  const caseSec = $('#caseSec'), caseBox = $('#caseBox');
  if(caseSec) caseSec.hidden = CASES.length === 0;


  const caseTitle = $('#caseTitle'), caseNote = $('#caseNote');
  if(caseTitle) caseTitle.textContent = STRAPS.length ? 'Case' : 'Case & strap';
  if(caseNote) caseNote.textContent = STRAPS.length
    ? 'Any case, any dial, any strap — every combination is the same price.'
    : 'Case and bracelet come as one set and always match.';
  if(caseBox && CASES.length){
    caseBox.innerHTML = CASES.map(c => `
      <button class="pick" data-case="${c.id}" aria-pressed="${state.case===c.id}" title="${c.name}">
        <span class="pick-dot" style="background:${c.dot || CASE_DOT[c.id] || c.hex || '#d8d4cc'}"></span>
        <span class="pick-name">${c.short || c.name}</span>
      </button>`).join('');
  }



  const bezSec = $('#bezelSec'), bezBox = $('#bezelBox');
  if(bezSec) bezSec.hidden = BEZELS.length === 0;
  if(bezBox && BEZELS.length){
    bezBox.innerHTML = BEZELS.map(b => `
      <button class="pick" data-bezel="${b.id}" aria-pressed="${state.bezel===b.id}"
              title="${b.name}${b.donor === state.model ? ' — stock pairing' : ''}">
        <span class="pick-dot" style="background:${b.hex || '#d8d4cc'}"></span>
        <span class="pick-name">${b.short || b.name}${b.donor === state.model ? '<i class="pick-rec">Recommended</i>' : ''}</span>
      </button>`).join('');
  }




  $('#dialBox').innerHTML = dialList().map(m => `
    <button class="pick" data-dial="${m.id}" aria-pressed="${state.model===m.id}" title="${m.name}">
      <span class="pick-dot" style="background:${DIAL_DOT[m.code] || m.hex || '#d8d4cc'}"></span>
      <span class="pick-name">${m.short || m.name}</span>
    </button>`).join('');

  $('#strapBox').innerHTML = STRAPS.map(s => `
    <button class="pick" data-strap="${s.id}" aria-pressed="${state.strap===s.id}" title="${s.name}">
      <span class="pick-dot" style="background:${s.hex}"></span>
      <span class="pick-name">${s.name}</span>
    </button>`).join('');



  const strapSec = $('#strapSec');
  if(strapSec) strapSec.hidden = STRAPS.length === 0;



  const dialNote = $('#dialNote');
  if(dialNote) dialNote.hidden = CASES.length === 0 && BEZELS.length === 0;

  $('#strapNote').textContent = CASES.length
    ? 'Any strap fits any case and dial — hands and markers stay the same. All combinations are the same price.'
    : 'Dials and straps mix freely — case, hands and markers stay the same. All combinations are the same price.';
}





function methodPriceText(t){
  if(t.mode === 'none')  return { main:'—', sub:'' };
  if(t.mode === 'laser') return { main: money(laserFee()), sub:'one-time' };
  if(t.mode === 'label'){
    const r = labelFeeRange();
    return { main: r ? (r[0] === r[1] ? money(r[0]) : money(r[0]) + '–' + money(r[1])) : 'quote',
             sub:'incl. tooling' };
  }
  return { main: money(printFeeNow(1)) + '+', sub:'by colour count' };
}

function buildMethods(){
  $('#methodBox').innerHTML = LOGO_METHODS.filter(t => t.mode !== 'none').map(t => {
    const p = methodPriceText(t);
    return `<button class="mcard" data-logotype="${t.id}" aria-pressed="${state.logoType===t.id}">
      <span class="mcard-dot"></span>
      <span>
        <span class="mcard-name">${t.name}</span>
        <span class="mcard-note">${t.note}</span>
      </span>
      <span class="mcard-price"><b>${p.main}</b><i>${p.sub}</i></span>
    </button>`;
  }).join('');
  buildSubOptions();
  renderWarn();
}


function buildSubOptions(){
  const t = method();
  const labelBox = $('#labelBox'), printBox = $('#printBox');
  const hasLogo = !!state.logo;

  labelBox.style.display = (hasLogo && t.mode === 'label') ? 'block' : 'none';
  printBox.style.display = (hasLogo && t.mode === 'print') ? 'block' : 'none';

  if(hasLogo && t.mode === 'label'){


    $('#swatchBox').innerHTML = LABEL_COLORS.map(c => {
      const dot = c.hex === 'other'
        ? 'background:conic-gradient(#e05555,#e8c33a,#57b46a,#3f8fd0,#9b5fc0,#e05555)'
        : `background:${c.hex}`;
      const lf = labelFee(c);
      const price = lf == null ? 'quote' : money(lf);
      return `<button class="sw" data-labelcolor="${c.id}" aria-pressed="${state.labelColor===c.id}">
        <span class="sw-dot" style="${dot}"></span>
        <span class="sw-name">${c.name}</span>
        <span class="sw-price">${price}</span>
      </button>`;
    }).join('');

    const c = labelColor();
    const lf = labelFee(c);
    $('#labelFormula').innerHTML = lf == null
      ? `Tooling <b>${money(LABEL_MOLD)}</b> (one-time, always charged) + material colour <b>quote needed</b>`
      : `Tooling <b>${money(LABEL_MOLD)}</b> (one-time, always charged) + material colour <b>${money(c.usd)}</b> = <b>${money(lf)}</b>`;
  }

  if(hasLogo && t.mode === 'print'){
    const suggest = state.logoMeta ? state.logoMeta.colors : null;
    const n = state.printColors;
    let html = '';
    for(let i = 1; i <= PRINT_MAX_COLORS; i++){
      const sug = (suggest && i === suggest) ? ' class="sug"' : '';
      html += `<button data-printcolors="${i}"${sug} aria-pressed="${n===i}">
        <b>${i}</b><i>${money(printFeeNow(i))}</i>
      </button>`;
    }
    $('#printColorBox').innerHTML = html;
    let hint = '';
    if(suggest){
      const head = `The artwork has about <b>${suggest}</b> colour${suggest>1?'s':''}`;
      if(suggest === n)      hint = `<br>${head} — the green dot is the auto-match.`;
      else if(suggest > n)   hint = `<br>⚠ ${head} — printing ${n} will lose some of them.`;
      else                   hint = `<br>ⓘ ${head} — ${n} colour${n>1?'s':''} is more than the artwork needs.`;
    }


    const shown = printFeeNow(n), extra = n - 1;
    const consistent = Math.abs(shown - printFee(n)) < 0.005;
    let body;
    if(!consistent)
      body = `<b>${money(shown)}</b> for ${n} colour${n>1?'s':''}`;
    else if(extra > 0)
      body = `<b>${money(PRINT_FIRST)}</b> for the first colour + <b>${money(PRINT_EXTRA)}</b> × ${extra} extra colour${extra>1?'s':''} = <b>${money(shown)}</b>`;
    else
      body = `<b>${money(PRINT_FIRST)}</b> flat for a single colour`;
    $('#printFormula').innerHTML = body + hint;
  }
}

function buildQty(){
  const btns = QTY_TIERS.map(t =>
    `<button data-qty="${t.qty}" aria-pressed="${!state.custom && state.qty === t.qty}">${t.label}</button>`
  ).join('');
  $('#qtyBox').innerHTML = btns + `
    <label class="qty-custom">
      <input type="number" id="qtyInput" min="1" max="99999" step="1"
             value="${state.custom ? state.qty : ''}" placeholder="Custom quantity">
      <span>pcs</span>
    </label>`;
}




function markLum(){
  const t = method();
  if(t.mode === 'laser') return LASER_LUM;
  if(t.mode === 'label') return labelColor().lum;
  return state.logoMeta ? state.logoMeta.avgLum : 128;
}




function logoWarnings(){
  const out = [];
  if(!state.logo) return out;
  const m = method(), meta = state.logoMeta, md = model();
  if(!meta || m.mode === 'none') return out;


  if(!meta.isMono && (m.mode === 'laser' || m.mode === 'label')){
    out.push({ level:'block',
      text:`${m.name} can only do one colour, and this logo is full colour. Switch to printing, or use a 1-colour version of the logo.` });
    return out;
  }


  if(m.mode === 'label' && labelColor().usd == null){
    out.push({ level:'block', text:'There is no fixed price for custom label colours. Send the colour reference to the factory first — this order can\'t be formally quoted yet.' });
  }




  const chromatic = m.mode === 'label' && (state.labelColor === 'gold' || state.labelColor === 'rose');
  if(meta.isMono && m.mode !== 'none' && !chromatic){
    const dl = md.dialLum, ml = markLum(), gap = Math.abs(dl - ml);
    if(gap < 58){
      out.push({ level:'block', text: m.mode === 'laser'
        ? `Laser engraves in a fixed warm off-white, and this dial (${md.name}) is already very light — it would barely be visible. Use a label or printing.`
        : `The logo and this dial (${md.name}) are only ${gap.toFixed(0)} apart in brightness — it would be almost invisible. Change the colour or the dial.` });
    }
  }


  if(m.mode === 'print' && meta.colors && state.printColors < meta.colors){
    out.push({ level:'tip',
      text:`The artwork has about ${meta.colors} colours; printing ${state.printColors} will lose some of them.` });
  }







  const L = state.logo, d = md.dial;
  const far = Math.hypot(Math.max(Math.abs(L.x-d.cx), Math.abs(L.x+L.w-d.cx)),
                         Math.max(Math.abs(L.y-d.cy), Math.abs(L.y+L.h-d.cy)));
  if(far > d.r * 0.86){
    out.push({ level:'tip', text:'The logo is too close to the edge — it overlaps the minute track / dial wall and can\'t be produced like this.' });
  }
  return out;
}

function renderWarn(){
  const box = $('#logoWarn'), list = logoWarnings();
  if(!list.length){ box.style.display = 'none'; box.innerHTML = ''; return; }
  box.style.display = 'grid';
  box.innerHTML = list.map(w =>
    `<div class="${w.level==='block'?'warnline':'tipline'}">${w.level==='block'?'⚠':'ⓘ'} ${w.text}</div>`
  ).join('');
}






function calc(){

  const unit = qtyUnitPrice(state.qty);
  const goods = unit * state.qty;


  const base100 = qtyUnitPrice(100);
  const factor = base100 > 0 ? unit / base100 : 1;

  const fee = logoFee();

  const fp = feeVariantPrice();
  if(fp != null) fee.usd = fp;

  const feeUsd = fee.usd == null ? 0 : fee.usd;

  const eng = engraveFee();
  const engUsd = eng.usd == null ? 0 : eng.usd;
  const total = goods + feeUsd + engUsd;

  const problems = [];
  if(state.logo && state.logoType === 'LG0') problems.push('Logo uploaded but no method chosen');
  if(fee.usd == null) problems.push('Custom label colour needs a factory quote');
  if(state.engrave && !(state.engraveText || '').trim())
    problems.push('Add the engraving text (letters and numbers, max ' + ENGRAVE_MAX + ')');
  logoWarnings().filter(w => w.level === 'block').forEach(w => problems.push(w.text));

  return { factor, unit, base100, goods, fee, feeUsd, eng, engUsd, total, problems,
           firm: problems.length === 0 };
}

function configCode(){




  const seg = ['CFG'];


  if(CASES.length && caseOf()) seg.push(caseOf().code);
  seg.push(model().code || 'STD');

  if(BEZELS.length && bezel()) seg.push(bezel().code);
  seg.push(strap() ? strap().code : 'STD');
  if(state.logo){
    const t = method();
    seg.push(t.id);
    if(t.mode === 'label') seg.push(state.labelColor.toUpperCase());
    if(t.mode === 'print') seg.push(state.printColors + 'C');
  }


  if(state.engrave) seg.push('ENG-' + engraveFont().code);
  return seg.join('-');
}

function renderSummary(){
  const r = calc();
  const m = model();

  $('#statusBox').innerHTML = r.firm
    ? `<span class="status firm">● Ready for a formal quote</span>`
    : `<span class="status hold">● ${r.problems.length} item${r.problems.length>1?'s':''} to confirm · prices are indicative</span>`;

  const rows = [];




  const qtyText = state.qty + (state.qty === 1 ? ' pc' : ' pcs');
  rows.push(`<div class="cfg-row"><span>${MODEL_LABEL} watch · ${qtyText}</span><span>${money(r.unit)} / pc</span></div>`);
  rows.push(`<div class="cfg-row"><span>Watch subtotal</span><span>${money(r.goods)}</span></div>`);

  if(r.fee.usd){
    rows.push(`<div class="cfg-row hr"><span>Logo · one-time</span>
      <span>${money(r.fee.usd)}</span></div>`);
    if(r.fee.items.length > 1){
      r.fee.items.forEach(it => {
        rows.push(`<div class="cfg-row sub"><span style="padding-left:10px">· ${it.n}</span>
          <span>${it.usd == null ? 'quote needed' : money(it.usd)}</span></div>`);
      });
    }
    rows.push(`<div class="cfg-row sub"><span style="padding-left:10px">Charged once, not per unit</span><span></span></div>`);
  }else if(r.fee.usd == null){
    rows.push(`<div class="cfg-row hr"><span>Logo · one-time</span><span>quote needed</span></div>`);
  }



  if(r.eng.usd){
    const etxt = (state.engraveText || '').trim();
    rows.push(`<div class="cfg-row hr"><span>Case back engraving · one-time</span>
      <span>${money(r.eng.usd)}</span></div>`);
    rows.push(`<div class="cfg-row sub"><span style="padding-left:10px">· ${engraveFont().name}${
      etxt ? ' · “' + etxt + '”' : ' · text pending'}</span><span></span></div>`);
  }

  if(CASES.length && caseOf())
    rows.push(`<div class="cfg-row sub"><span>Case &amp; strap</span><span>${caseOf().name}</span></div>`);
  rows.push(`<div class="cfg-row sub"><span>Dial</span><span>${m.name}</span></div>`);
  if(BEZELS.length && bezel())
    rows.push(`<div class="cfg-row sub"><span>Bezel</span><span>${bezel().name}</span></div>`);

  if(strap())
    rows.push(`<div class="cfg-row sub"><span>Strap</span><span>${strap().name}</span></div>`);

  $('#breakdown').innerHTML = rows.join('');
  $('#configCode').textContent = configCode();
  $('#actTotal').textContent = money(r.total, 0);
  $('#actUsd').textContent = money(r.unit) + ' / pc · USD';

  $('#actQty').textContent = state.qty + (state.qty === 1 ? ' pc' : ' pcs');
  renderCartBtn();
}







function countColors(d){
  const cells = new Map();
  let opaque = 0;
  for(let i = 0; i < d.length; i += 4){
    if(d[i+3] < 80) continue;
    opaque++;
    const k = ((d[i]>>6)<<4) | ((d[i+1]>>6)<<2) | (d[i+2]>>6);
    cells.set(k, (cells.get(k) || 0) + 1);
  }
  if(!opaque) return 1;
  const kept = [];
  cells.forEach((c, k) => {
    if(c / opaque < 0.05) return;
    kept.push({ r:((k>>4)&3)*85, g:((k>>2)&3)*85, b:(k&3)*85, c });
  });
  kept.sort((a, b) => b.c - a.c);
  const merged = [];
  kept.forEach(cell => {
    const near = merged.find(o => Math.hypot(o.r-cell.r, o.g-cell.g, o.b-cell.b) < 78);
    if(near) near.c += cell.c; else merged.push({ ...cell });
  });
  return Math.max(1, Math.min(PRINT_MAX_COLORS, merged.length));
}

function analyzeLogo(src, cb){
  const img = new Image();
  img.onload = () => {
    try{
      const S = 72, cv = document.createElement('canvas');
      cv.width = S; cv.height = S;
      const x = cv.getContext('2d');
      x.drawImage(img, 0, 0, S, S);
      const d = x.getImageData(0, 0, S, S).data;
      let colored = 0, total = 0, lum = 0;
      for(let i = 0; i < d.length; i += 4){
        if(d[i+3] < 40) continue;
        const r = d[i], g = d[i+1], b = d[i+2];
        const mx = Math.max(r,g,b), mn = Math.min(r,g,b);
        total++; lum += 0.299*r + 0.587*g + 0.114*b;
        if(mx - mn > 42) colored++;
      }
      const isMono = total ? (colored/total) < 0.05 : true;
      cb({ isMono,
           avgLum: total ? lum/total : 128,
           coloredRatio: total ? colored/total : 0,
           colors: isMono ? 1 : countColors(d) });
    }catch(e){ cb({ isMono:true, avgLum:128, coloredRatio:0, colors:1 }); }
  };
  img.onerror = () => cb({ isMono:true, avgLum:128, coloredRatio:0, colors:1 });
  img.src = src;
}

$('#logoFile').addEventListener('change', e => {
  const f = e.target.files && e.target.files[0];
  if(!f) return;
  const rd = new FileReader();
  rd.onload = () => {
    const img = new Image();
    img.onload = () => {
      const m = model();
      const w = m.dial.r * 0.46;
      const h = w * (img.height / img.width);
      state.logo = {
        src: rd.result, w, h,
        x: m.dial.cx - w/2,
        y: m.dial.cy - m.dial.r * 0.38 - h/2,
        rot: 0, opa: 1
      };
      $('#logoCtl').style.display = 'block';
      $('#posSec').style.display = 'block';

      const pw = document.getElementById('posToggleWrap');
      if(pw) pw.hidden = false;
      $('#uploadLabel').textContent = 'Uploaded: ' + f.name;


      const ub = $('#uploadBox');
      if(ub){ ub.classList.add('has-file'); ub.title = f.name; }
      const uh = $('#uploadHint');
      if(uh) uh.textContent = 'Click to replace';
      $('#lgSize').value = Math.round(w); $('#lgSizeV').textContent = Math.round(w);
      $('#lgRot').value = 0;  $('#lgRotV').textContent = '0°';
      $('#lgOpa').value = 100; $('#lgOpaV').textContent = '100%';

      $('#hint').textContent = 'Drag the logo to move it · drag a corner to resize';
      $('#hint').hidden = false;

      analyzeLogo(rd.result, meta => {
        state.logoMeta = meta;


        if(state.logoType === 'LG0'){
          state.logoType = meta.isMono ? (model().dialLum > 170 ? 'LG2' : 'LG1') : 'LG3';
        }
        if(meta.isMono){
          state.labelColor = model().isDark ? 'white' : 'black';
        }
        state.printColors = Math.max(1, Math.min(PRINT_MAX_COLORS, meta.colors || 1));
        buildMethods();
        renderLogo(); renderWarn(); renderSummary();




        const cb = document.getElementById('posToggle');
        if(cb) cb.checked = true;
        openZoom();
      });
    };
    img.src = rd.result;
  };
  rd.readAsDataURL(f);
});


document.querySelectorAll('[data-preset]').forEach(btn => {
  btn.addEventListener('click', () => {
    const p = btn.dataset.preset, m = model(), L = state.logo;
    if(p === 'clear'){
      state.logo = null; state.logoMeta = null;
      state.logoType = 'LG0'; state.labelColor = 'black'; state.printColors = 1;
      $('#logoCtl').style.display = 'none';
      $('#posSec').style.display = 'none';

      const pw = document.getElementById('posToggleWrap');
      if(pw) pw.hidden = true;
      closeZoom();
      $('#uploadLabel').textContent = 'Upload customer logo (transparent PNG)';
      const ub = $('#uploadBox');
      if(ub){ ub.classList.remove('has-file'); ub.removeAttribute('title'); }
      const uh = $('#uploadHint');
      if(uh) uh.textContent = 'Laser engraving / label / printing — checked automatically after upload';
      $('#hint').textContent = '';
      $('#hint').hidden = true;
      buildMethods(); renderLogo(); renderSummary();
      return;
    }
    if(!L) return;
    if(p === '12'){ L.x = m.dial.cx - L.w/2; L.y = m.dial.cy - m.dial.r * 0.38 - L.h/2; }
    if(p === '6'){ L.x = m.dial.cx - L.w/2; L.y = m.dial.cy + m.dial.r * 0.34 - L.h/2; }
    if(p === 'center'){ L.x = m.dial.cx - L.w/2; L.y = m.dial.cy - L.h/2; }
    renderLogo(); renderWarn();
  });
});

function bindSlider(id, valId, apply, fmt){
  const el = $(id);
  el.addEventListener('input', () => {
    if(!state.logo) return;
    apply(+el.value);
    $(valId).textContent = fmt ? fmt(el.value) : el.value;
    renderLogo(); renderWarn();
  });
}
bindSlider('#lgSize', '#lgSizeV', v => {
  const L = state.logo, ratio = L.h / L.w;
  const cx = L.x + L.w/2, cy = L.y + L.h/2;
  L.w = v; L.h = v * ratio;
  L.x = cx - L.w/2; L.y = cy - L.h/2;
});
bindSlider('#lgRot', '#lgRotV', v => { state.logo.rot = v; }, v => v + '°');
bindSlider('#lgOpa', '#lgOpaV', v => { state.logo.opa = v/100; }, v => v + '%');


function toSvg(evt){
  const pt = svg.createSVGPoint();
  pt.x = evt.clientX; pt.y = evt.clientY;
  return pt.matrixTransform(svg.getScreenCTM().inverse());
}
let drag = null;
svg.addEventListener('pointerdown', e => {
  if(e.target.id !== 'logoImg' || !state.logo) return;
  const p = toSvg(e);
  drag = { px: p.x, py: p.y, ox: state.logo.x, oy: state.logo.y };
  showBox(true);
  svg.setPointerCapture(e.pointerId);
  e.preventDefault();
});
svg.addEventListener('pointermove', e => {
  if(!drag) return;
  const p = toSvg(e);
  state.logo.x = drag.ox + (p.x - drag.px);
  state.logo.y = drag.oy + (p.y - drag.py);
  renderLogo();
});
svg.addEventListener('pointerup', () => { if(drag){ drag = null; renderWarn(); } });
svg.addEventListener('pointercancel', () => { drag = null; });
svg.addEventListener('wheel', e => {
  if(!state.logo) return;
  const L = state.logo, p = toSvg(e);
  const cx = L.x + L.w/2, cy = L.y + L.h/2;
  if(Math.hypot(p.x-cx, p.y-cy) > Math.max(L.w, L.h)/2 + 40) return;
  e.preventDefault();
  const k = e.deltaY < 0 ? 1.06 : 0.94;
  const nw = Math.min(700, Math.max(40, L.w * k));
  const ratio = L.h / L.w;
  L.w = nw; L.h = nw * ratio;
  L.x = cx - L.w/2; L.y = cy - L.h/2;
  $('#lgSize').value = Math.round(L.w); $('#lgSizeV').textContent = Math.round(L.w);
  renderLogo(); renderWarn();
}, { passive:false });




function svgToPng(cb, scale){
  scale = scale || 1;
  const clone = svg.cloneNode(true);
  const box = clone.querySelector('#logoBox'); if(box) box.remove();
  const guide = clone.querySelector('#gGuide'); if(guide) guide.remove();
  clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  clone.setAttribute('width', 2000*scale);
  clone.setAttribute('height', 2000*scale);
  const s = new XMLSerializer().serializeToString(clone);
  const url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(s);
  const img = new Image();
  img.onload = () => {
    const c = document.createElement('canvas');
    c.width = 2000*scale; c.height = 2000*scale;
    const x = c.getContext('2d');
    x.fillStyle = '#ffffff'; x.fillRect(0,0,c.width,c.height);
    x.drawImage(img, 0, 0, c.width, c.height);
    try{ cb(c.toDataURL('image/png')); }catch(err){ cb(null); }
  };
  img.onerror = () => cb(null);
  img.src = url;
}

function download(name, href){
  const a = document.createElement('a');
  a.href = href; a.download = name;
  document.body.appendChild(a); a.click(); a.remove();
}

$('#btnPng').addEventListener('click', () => {
  svgToPng(d => {
    if(!d){ alert('Export failed. Open the page over http:// rather than double-clicking the file.'); return; }
    download(configCode() + '.png', d);
  });
});







const ZOOM = { scale: 1, x: 0, y: 0, open: false };






function zoomSvg(){
  const src = document.getElementById('watch');
  if(!src) return null;
  const clone = src.cloneNode(true);
  const map = new Map();



  [clone].concat(Array.from(clone.querySelectorAll('[id]'))).forEach(el => {
    if(!el.id) return;
    map.set(el.id, 'z-' + el.id);
    el.id = 'z-' + el.id;
  });

  [clone].concat(Array.from(clone.querySelectorAll('*'))).forEach(el => {
    Array.from(el.attributes).forEach(a => {
      if(a.value.indexOf('#') < 0) return;
      const nv = a.value
        .replace(/url\(#([^)]+)\)/g, (m, id) => map.has(id) ? 'url(#' + map.get(id) + ')' : m)
        .replace(/^#([^)\s]+)$/, (m, id) => map.has(id) ? '#' + map.get(id) : m);
      if(nv !== a.value) el.setAttribute(a.name, nv);
    });
  });

  clone.removeAttribute('width');
  clone.removeAttribute('height');
  clone.removeAttribute('style');
  clone.setAttribute('preserveAspectRatio', 'xMidYMid meet');
  return clone;
}

function applyZoomTf(){
  const svg = document.querySelector('#zoomStage > svg');
  if(svg) svg.style.transform =
    'translate(' + ZOOM.x + 'px,' + ZOOM.y + 'px) scale(' + ZOOM.scale + ')';
}

function resetZoom(){ ZOOM.scale = 1; ZOOM.x = 0; ZOOM.y = 0; applyZoomTf(); }



function dialViewBox(){
  const d = model().dial;
  const pad = d.r * 1.28;
  return { x: d.cx - pad, y: d.cy - pad, w: pad * 2, h: pad * 2 };
}


function syncZoomChrome(){
  const zbLogo = document.getElementById('zbLogo');
  const hint = document.getElementById('zoomHint');
  if(zbLogo) zbLogo.hidden = !state.logo;
  if(hint) hint.textContent = state.logo
    ? 'Drag the logo to move it · drag a corner to resize'
    : 'Pinch or scroll to zoom the dial';
}


function nudgeLogo(dir){
  const L = state.logo;
  if(!L) return;
  const step = Math.max(4, Math.round(L.w * 0.08));
  if(dir === 'left')  L.x -= step;
  if(dir === 'right') L.x += step;
  if(dir === 'up')    L.y -= step;
  if(dir === 'down')  L.y += step;
  renderLogo(); syncZoomLogo(); renderWarn();
}





function clampLogoW(w){
  const r = model().dial.r;
  return Math.min(r * 1.9, Math.max(r * 0.06, w));
}



function syncSizeSlider(){
  const el = document.getElementById('lgSize');
  if(!el || !state.logo) return;
  const w = Math.round(state.logo.w);
  el.value = w;
  const v = document.getElementById('lgSizeV');
  if(v) v.textContent = w;
}


function openZoom(){
  const layer = $('#zoom'), stage = $('#zoomStage');
  if(!layer || !stage || ZOOM.open) return;
  if(!state.logo) return;
  const svg = zoomSvg();
  if(!svg) return;
  stage.innerHTML = '';
  stage.appendChild(svg);



  syncZoomLogo();


  const vb = dialViewBox();
  svg.setAttribute('viewBox', `${vb.x} ${vb.y} ${vb.w} ${vb.h}`);


  if(layer.showModal) layer.showModal();
  else layer.setAttribute('open', '');
  ZOOM.open = true;
  resetZoom();
  syncZoomChrome();
  document.body.style.overflow = 'hidden';
}

function closeZoom(){
  const layer = $('#zoom'), stage = $('#zoomStage');
  if(!layer || !ZOOM.open) return;
  if(layer.close) layer.close();
  else layer.removeAttribute('open');


  ZOOM.open = false;
  if(stage) stage.innerHTML = '';
  document.body.style.overflow = '';

  const cb = document.getElementById('posToggle');
  if(cb) cb.checked = false;
}

(function bindZoom(){
  const layer = $('#zoom'), stage = $('#zoomStage');
  const closeBtn = $('#zoomClose');
  if(!layer || !stage) return;

  if(closeBtn) closeBtn.addEventListener('click', closeZoom);
  document.addEventListener('keydown', e => {
    if(e.key === 'Escape' && ZOOM.open) closeZoom();
  });



  layer.addEventListener('close', () => {
    ZOOM.open = false;
    if(stage) stage.innerHTML = '';
    document.body.style.overflow = '';
    const cb = document.getElementById('posToggle');
    if(cb) cb.checked = false;
  });


  layer.addEventListener('click', e => {
    if(e.target === layer || e.target === stage) closeZoom();
  });

  let pinchDist = 0, pinchBase = 1, pan = null, zDrag = null, zScale = null;

  stage.addEventListener('touchstart', e => {
    if(zDrag || zScale) return;
    if(e.touches.length === 2){
      pinchDist = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY);
      pinchBase = ZOOM.scale;
    } else if(e.touches.length === 1 && ZOOM.scale > 1){
      pan = { x: e.touches[0].clientX - ZOOM.x, y: e.touches[0].clientY - ZOOM.y };
    }
  }, { passive: true });

  stage.addEventListener('touchmove', e => {
    if(zDrag || zScale) return;
    if(e.touches.length === 2 && pinchDist > 0){
      e.preventDefault();
      const d = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY);
      ZOOM.scale = Math.min(6, Math.max(1, pinchBase * d / pinchDist));
      if(ZOOM.scale <= 1){ ZOOM.x = 0; ZOOM.y = 0; }
      applyZoomTf();
    } else if(pan && e.touches.length === 1 && ZOOM.scale > 1){
      e.preventDefault();
      ZOOM.x = e.touches[0].clientX - pan.x;
      ZOOM.y = e.touches[0].clientY - pan.y;
      applyZoomTf();
    }
  }, { passive: false });

  stage.addEventListener('touchend', e => {
    if(e.touches.length < 2) pinchDist = 0;
    if(e.touches.length === 0) pan = null;
  });


  let lastTap = 0;
  stage.addEventListener('click', e => {
    if(!e.target.closest('svg')) return;
    if(e.target.id === 'z-logoImg') return;
    const now = Date.now();
    if(now - lastTap < 320){
      lastTap = 0;
      if(ZOOM.scale > 1.2) resetZoom();
      else { ZOOM.scale = 2.6; ZOOM.x = 0; ZOOM.y = 0; applyZoomTf(); }
    } else {
      lastTap = now;
    }
  });


  stage.addEventListener('wheel', e => {
    if(!ZOOM.open) return;
    e.preventDefault();
    ZOOM.scale = Math.min(6, Math.max(1, ZOOM.scale * (e.deltaY < 0 ? 1.12 : 0.89)));
    if(ZOOM.scale <= 1){ ZOOM.x = 0; ZOOM.y = 0; }
    applyZoomTf();
  }, { passive: false });


  const bar = document.getElementById('zoomBar');
  if(bar){
    bar.addEventListener('click', e => {
      const zb = e.target.closest('[data-zoom]');
      if(zb){
        const a = zb.dataset.zoom;
        if(a === 'reset'){ resetZoom(); }
        else {
          ZOOM.scale = Math.min(6, Math.max(1, ZOOM.scale * (a === 'in' ? 1.18 : 0.85)));
          if(ZOOM.scale <= 1){ ZOOM.x = 0; ZOOM.y = 0; }
          applyZoomTf();
        }
        return;
      }
      const nb = e.target.closest('[data-nudge]');
      if(nb){ nudgeLogo(nb.dataset.nudge); return; }
      if(e.target.closest('#zoomDone')) closeZoom();
    });
  }




  function toSvgEl(svgEl, evt){
    const pt = svgEl.createSVGPoint();
    pt.x = evt.clientX; pt.y = evt.clientY;
    return pt.matrixTransform(svgEl.getScreenCTM().inverse());
  }
  stage.addEventListener('pointerdown', e => {
    if(!state.logo) return;
    const tid = (e.target && e.target.id) || '';
    const svgEl = stage.querySelector('svg');
    if(!svgEl) return;





    if(tid.indexOf('z-handle-') === 0){
      const p = toSvgEl(svgEl, e);
      const L = state.logo;
      const cx = L.x + L.w/2, cy = L.y + L.h/2;
      zScale = { cx, cy, w0: L.w, h0: L.h,
                 d0: Math.max(1, Math.hypot(p.x - cx, p.y - cy)) };
      try{ svgEl.setPointerCapture(e.pointerId); }catch(_){}
      e.preventDefault(); e.stopPropagation();
      return;
    }

    if(tid !== 'z-logoImg') return;
    const p = toSvgEl(svgEl, e);
    zDrag = { px:p.x, py:p.y, ox:state.logo.x, oy:state.logo.y };
    try{ svgEl.setPointerCapture(e.pointerId); }catch(_){}
    e.preventDefault(); e.stopPropagation();
  });
  stage.addEventListener('pointermove', e => {
    if(zScale){
      const svgEl = stage.querySelector('svg');
      if(!svgEl) return;
      const p = toSvgEl(svgEl, e);
      const d = Math.hypot(p.x - zScale.cx, p.y - zScale.cy);
      const w = clampLogoW(zScale.w0 * (d / zScale.d0));
      const L = state.logo;
      L.w = w;
      L.h = zScale.h0 * (w / zScale.w0);

      L.x = zScale.cx - L.w/2;
      L.y = zScale.cy - L.h/2;
      renderLogo(); syncZoomLogo(); syncSizeSlider();
      e.preventDefault();
      return;
    }
    if(!zDrag) return;
    const svgEl = stage.querySelector('svg');
    if(!svgEl) return;
    const p = toSvgEl(svgEl, e);
    state.logo.x = zDrag.ox + (p.x - zDrag.px);
    state.logo.y = zDrag.oy + (p.y - zDrag.py);
    renderLogo(); syncZoomLogo();
    e.preventDefault();
  });
  stage.addEventListener('pointerup', () => {
    if(zScale){ zScale = null; renderWarn(); syncSizeSlider(); }
    if(zDrag){ zDrag = null; renderWarn(); }
  });
  stage.addEventListener('pointercancel', () => { zScale = null; zDrag = null; });
})();




(function bindPosToggle(){
  const wrap = $('#posToggleWrap'), cb = $('#posToggle');
  if(!wrap || !cb) return;
  cb.addEventListener('change', () => {
    if(cb.checked) openZoom();
    else closeZoom();
  });
})();






function cartProps(){
  const m = model(), s = strap();
  const props = {
    'Configuration': configCode(),
    'Dial':  m.name,
    'Strap': s ? s.name : '—',
    'Logo':  state.logo ? logoDesc() : 'None',
    'Qty':   state.qty + ' pcs',
  };


  if(state.engrave){
    const etxt = (state.engraveText || '').trim();
    props['Case back engraving'] = engraveFont().name + ' / ' + (etxt || 'TEXT PENDING');
  }
  return props;
}
function logoDesc(){
  const t = method();
  if(t.mode === 'label') return t.name + ' / ' + labelColor().name;
  if(t.mode === 'print') return t.name + ' / ' + state.printColors +
                               (state.printColors > 1 ? ' colours' : ' colour');
  if(t.mode === 'laser') return t.name + ' / off-white';
  return t.name;
}



function addToCart(){
  const items = [{ id: qtyVariantId(state.qty), quantity: state.qty, properties: cartProps() }];
  const fv = feeVariantId();
  if(fv) items.push({ id: fv, quantity: 1 });

  const ev = engraveVariantId();
  if(ev) items.push({ id: ev, quantity: 1 });

  const form = document.createElement('form');
  form.method = 'post';
  form.action = '/cart/add';
  form.style.display = 'none';
  const add = (name, value) => {
    const i = document.createElement('input');
    i.type = 'hidden'; i.name = name; i.value = value;
    form.appendChild(i);
  };
  items.forEach(it => {
    add('items[][id]', it.id);
    add('items[][quantity]', it.quantity);
    for(const k in (it.properties || {})) add('items[][properties][' + k + ']', it.properties[k]);
  });
  add('return_to', '/checkout');
  document.body.appendChild(form);
  form.submit();
}


function renderCartBtn(){
  const btn = $('#btnCart'), note = $('#cartNote');
  if(!btn) return;
  if(canCheckout()){
    btn.textContent = 'Add to cart';
    btn.classList.add('primary');
    btn.removeAttribute('title');
    note.style.display = 'none';
  }else{
    btn.textContent = 'Request quote';
    btn.classList.remove('primary');

    let why;
    if(Object.keys(variantMaps().qty).length === 0)
      why = 'Direct ordering is not connected yet — ';
    else if(!qtyVariantId(state.qty))
      why = 'Custom quantity is priced per order — ';
    else if(state.engrave && !engraveVariantId())
      why = 'Case back engraving is priced per order — ';
    else
      why = 'This label colour is priced per order — ';
    note.textContent = why + 'generate the quotation and send it to us.';
    note.style.display = 'block';
  }
}

$('#btnCart').addEventListener('click', () => {
  if(canCheckout()) addToCart();
  else $('#btnQuote').click();
});

function colorLabel(){
  const t = method();
  if(!state.logo || t.mode === 'none') return '';
  if(t.mode === 'laser') return 'off-white (fixed)';
  if(t.mode === 'label') return labelColor().name;
  return state.printColors + (state.printColors > 1 ? ' colours' : ' colour');
}

$('#btnCopy').addEventListener('click', async () => {
  const r = calc(), m = model();
  const txt = [
    'Config code: ' + configCode(),
    'Model: ' + m.name + ' / strap ' + (strap() ? strap().name : '—'),
    (BEZELS.length && bezel()) ? 'Bezel: ' + bezel().name : null,
    'Logo: ' + (state.logo ? method().name + ' / ' + colorLabel() : 'none'),
    state.engrave
      ? 'Case back engraving: ' + engraveFont().name + ' / ' +
        ((state.engraveText || '').trim() || 'TEXT PENDING') +
        ' — ' + money(r.eng.usd) + ' (not affected by quantity)'
      : 'Case back engraving: none',
    'Quantity: ' + state.qty + ' pcs',
    'Watch subtotal: ' + money(r.goods),
    r.fee.usd == null
      ? 'Logo one-time cost: quote needed'
      : 'Logo one-time cost: ' + money(r.fee.usd) + ' (not affected by quantity)',
    'Total: ' + money(r.total) + ' USD',
    'Status: ' + (r.firm ? 'ready for a formal quote' : 'to confirm: ' + r.problems.join('; '))
  ].filter(v => v != null).join('\n');
  try{
    await navigator.clipboard.writeText(txt);
    $('#btnCopy').textContent = 'Copied ✓';
    setTimeout(() => $('#btnCopy').textContent = 'Copy spec', 1400);
  }catch(e){ alert(txt); }
});

$('#btnQuote').addEventListener('click', () => {
  const r = calc(), m = model(), lt = method();
  const feeRows = r.fee.items.length
    ? r.fee.items.map(it =>
        `<tr><td style="padding-left:22px;color:#6d7178">· ${it.n}</td>
             <td class="r">${it.usd == null ? 'quote needed' : money(it.usd)}</td></tr>`).join('')
    : '';
  const engTxt = (state.engraveText || '').trim();

  const today = new Date().toLocaleDateString('en-GB',
    { day:'2-digit', month:'short', year:'numeric' });



  svgToPng(dataUrl => {
    const html = `<!DOCTYPE html><html lang="en"><head><meta charset="utf-8">
<title>Quotation ${configCode()}</title>
<style>
 body{font-family:-apple-system,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;color:#1b1c1f;
      max-width:860px;margin:38px auto;padding:0 30px;font-size:13px;line-height:1.7}
 h1{font-size:20px;margin:0 0 4px} .muted{color:#6d7178;font-size:12px}
 .grid{display:flex;gap:26px;margin:24px 0;align-items:flex-start}
 .grid img{width:330px;border:1px solid #e5e2dc;border-radius:10px;background:#fff}
 table{width:100%;border-collapse:collapse;margin-top:6px}
 th,td{text-align:left;padding:7px 10px;border-bottom:1px solid #eeeae3;font-size:12.5px}
 th{font-size:11px;letter-spacing:.06em;color:#6d7178;text-transform:uppercase}
 .r{text-align:right;font-variant-numeric:tabular-nums}
 .tot{margin-top:16px;padding-top:12px;border-top:2px solid #1b1c1f;display:flex;
      justify-content:space-between;align-items:baseline}
 .tot b{font-size:22px}
 .once{margin-top:14px;padding:10px 12px;background:#f7f1e3;border:1px solid #ecdfc4;
       border-radius:8px;font-size:11.5px;color:#7a5c1e}
 .note{font-size:11.5px;color:#6d7178;margin-top:18px;border-top:1px dashed #ddd8cf;padding-top:12px}
 .st{display:inline-block;padding:3px 10px;border-radius:20px;font-size:11px;
     background:${r.firm?'#eaf4ee':'#fbf1de'};color:${r.firm?'#2c7a52':'#b0761a'}}
 @media print{body{margin:0}}
</style></head><body>
<h1>Watch customisation quotation</h1>
<div class="muted">Config code ${configCode()} ｜ ${today}</div>
<div class="grid">
  <div>${dataUrl ? `<img src="${dataUrl}" alt="Preview">` : '<div class="muted">(preview export failed)</div>'}</div>
  <div style="flex:1">
    <div><span class="st">${r.firm ? 'Ready for a formal quote' : 'Some items to confirm — prices are indicative'}</span></div>
    <table>
      <tr><th>Item</th><th>Detail</th></tr>
      <tr><td>Model</td><td>${m.name}</td></tr>
      ${(BEZELS.length && bezel()) ? `<tr><td>Bezel</td><td>${bezel().name}</td></tr>` : ''}
      <tr><td>Strap</td><td>${strap() ? strap().name : '—'}</td></tr>
      <tr><td>Logo method</td><td>${state.logo ? lt.name + ' · ' + colorLabel() : 'none'}</td></tr>
      <tr><td>Case back engraving</td><td>${state.engrave
        ? engraveFont().name + ' · ' + (engTxt || '<b>TEXT PENDING</b>')
        : 'none'}</td></tr>
      <tr><td>Quantity</td><td>${state.qty} pcs</td></tr>
      <tr><td>Unit price</td><td>${money(r.unit)} / pc</td></tr>
      <tr><td>Watch subtotal</td><td class="r">${money(r.goods)}</td></tr>
      ${r.fee.usd != null && r.fee.usd > 0 ? `<tr><td>Logo one-time cost</td><td class="r">${money(r.fee.usd)}</td></tr>${feeRows}` : ''}
      ${r.fee.usd == null ? '<tr><td>Logo one-time cost</td><td>quote needed</td></tr>' : ''}
      ${r.eng.usd ? `<tr><td>Engraving one-time cost</td><td class="r">${money(r.eng.usd)}</td></tr>` : ''}
    </table>
  </div>
</div>
${(r.fee.usd || r.eng.usd) ? `<div class="once"><b>Logo and engraving costs are charged once.</b> Ordering 1 pc or ${state.qty} pcs costs the same for these items — they are not multiplied by quantity.</div>` : ''}
<div class="tot"><span>Estimated total</span><b>${money(r.total)} USD</b></div>
<div class="muted" style="margin-top:4px">${money(r.unit)} per pc · all prices in USD</div>
<div class="note">
  · The preview is composited from real product photography; final logo position and size follow the approved artwork.<br>
  · Prices exclude shipping, duties and custom packaging.<br>
  · Please supply logo artwork as AI / PDF / PNG with transparent background, 1000 px or larger.<br>
  · Lead time and final pricing are confirmed on the formal PI.
</div>
</body></html>`;
    download('Quotation-' + configCode() + '.html',
      'data:text/html;charset=utf-8,' + encodeURIComponent(html));
  }, 0.45);
});












$('#caseBox').addEventListener('click', e => {
  const b = e.target.closest('[data-case]');
  if(!b) return;
  state.case = b.dataset.case;
  applyModel();
  buildPicks();
  renderGuide();
  renderLogo(); renderWarn(); renderSummary();
});

$('#dialBox').addEventListener('click', e => {
  const b = e.target.closest('[data-dial]');
  if(!b) return;
  state.model = b.dataset.dial;


  if(BEZELS.length && !state.bezelPinned) state.bezel = defaultBezelFor(state.model);
  applyModel();
  buildPicks();
  renderGuide();
  renderLogo(); renderWarn(); renderSummary();
});


if($('#bezelBox')) $('#bezelBox').addEventListener('click', e => {
  const b = e.target.closest('[data-bezel]');
  if(!b) return;
  state.bezel = b.dataset.bezel;
  state.bezelPinned = true;
  applyModel();
  buildPicks();
  renderSummary();
});



$('#strapBox').addEventListener('click', e => {
  const b = e.target.closest('[data-strap]');
  if(!b) return;
  state.strap = b.dataset.strap;
  applyModel();
  buildPicks();
  renderSummary();
});

$('#methodBox').addEventListener('click', e => {
  const b = e.target.closest('[data-logotype]');
  if(!b) return;
  state.logoType = b.dataset.logotype;
  buildMethods(); renderLogo(); renderWarn(); renderSummary();
});

$('#swatchBox').addEventListener('click', e => {
  const b = e.target.closest('[data-labelcolor]');
  if(!b) return;
  state.labelColor = b.dataset.labelcolor;
  buildSubOptions(); renderLogo(); renderWarn(); renderSummary();
});

$('#printColorBox').addEventListener('click', e => {
  const b = e.target.closest('[data-printcolors]');
  if(!b) return;
  state.printColors = +b.dataset.printcolors;
  buildSubOptions(); renderLogo(); renderWarn(); renderSummary();
});

$('#qtyBox').addEventListener('click', e => {
  const b = e.target.closest('[data-qty]');
  if(!b) return;
  state.custom = false;
  state.qty = +b.dataset.qty;
  buildQty(); renderWarn(); renderSummary();
});



$('#qtyBox').addEventListener('input', e => {
  if(e.target.id !== 'qtyInput') return;
  const raw = e.target.value;
  state.custom = raw !== '';
  if(state.custom){
    state.qty = Math.max(1, Math.min(99999, Math.floor(+raw || 1)));
  }
  document.querySelectorAll('#qtyBox [data-qty]').forEach(b =>
    b.setAttribute('aria-pressed', String(!state.custom && +b.dataset.qty === state.qty)));
  renderWarn(); renderSummary();
});






function showBox(on){
  const b = document.querySelector('#logoBox');
  if(b) b.setAttribute('opacity', on ? '0.8' : '0');
}
svg.addEventListener('pointerover', e => { if(e.target.id === 'logoImg') showBox(true); });
svg.addEventListener('pointerout',  e => { if(e.target.id === 'logoImg') showBox(false); });






function bindCompact(){


  const panel = document.querySelector('.cfg .panel') || document.querySelector('.panel');
  const main = panel && (panel.closest('main') || document.querySelector('main'));
  if(!main || !panel) return;
  const mq = window.matchMedia('(max-width:900px)');
  function apply(){
    if(!mq.matches){ main.classList.remove('is-compact'); return; }
    const y = panel.scrollTop;
    const on = main.classList.contains('is-compact');
    if(!on && y > 24) main.classList.add('is-compact');
    else if(on && y < 8) main.classList.remove('is-compact');
  }
  panel.addEventListener('scroll', apply, { passive: true });
  if(mq.addEventListener) mq.addEventListener('change', apply);
  else if(mq.addListener) mq.addListener(apply);
  apply();
}




function buildEngraving(){
  const box = $('#engFontBox');
  if(box){
    box.innerHTML = ENGRAVE_FONTS.map(f => `
      <button type="button" class="engfont" data-engfont="${f.id}"
              aria-pressed="${state.engraveFont === f.id}">
        <span class="engfont-sample" style="font-family:${f.stack}">Aa</span>
        <span class="engfont-name">${f.name}</span>
      </button>`).join('');
  }
  const price = $('#engPrice');
  if(price){
    const p = engraveVariantPrice();
    price.textContent = money(p != null ? p : ENGRAVE_FEE, 0);
  }
  const body = $('#engBody');
  if(body) body.hidden = !state.engrave;
  const on = $('#engOn');
  if(on) on.checked = state.engrave;
  const txt = $('#engText');
  if(txt && txt.value !== state.engraveText) txt.value = state.engraveText;
  updateEngCount();
}

function updateEngCount(){
  const txt = $('#engText'), c = $('#engCount'), wrap = $('#engInputWrap');
  if(!txt || !c) return;
  const n = (txt.value || '').length;
  c.textContent = n + '/' + ENGRAVE_MAX;
  if(wrap) wrap.classList.toggle('bad', state.engrave && n === 0);
}

$('#engOn').addEventListener('change', e => {
  state.engrave = e.target.checked;
  buildEngraving();
  renderSummary();

  if(state.engrave && $('#engText')) $('#engText').focus();
});

$('#engFontBox').addEventListener('click', e => {
  const b = e.target.closest('[data-engfont]');
  if(!b) return;
  state.engraveFont = b.dataset.engfont;
  buildEngraving();
  renderSummary();
});

$('#engText').addEventListener('input', e => {


  const v = e.target.value.replace(/[^A-Za-z0-9 ]/g, '').slice(0, ENGRAVE_MAX);
  if(v !== e.target.value) e.target.value = v;
  state.engraveText = v;
  updateEngCount();
  renderSummary();
});

function boot(){
  if(!MODELS.length){
    document.getElementById('cfgRoot').innerHTML =
      '<p style="padding:40px;font-family:sans-serif">models-data.js is missing — '
      + 'upload it to the theme Assets folder.</p>';
    return;
  }
  applyModel();
  buildPicks();
  buildMethods();
  buildEngraving();
  buildQty();
  renderGuide();
  renderLogo();

  const adminSpecs = specsFromAdmin();
  if(adminSpecs) WATCH_SPECS = adminSpecs;
  renderSpecs();
  placeSpecs();
  renderSummary();
  bindCompact();






  preload().then(() => { applyModel(); });
}
boot();
